/* eslint-disable no-param-reassign, default-case */
import ItemPackage from 'es6/models/item-package';
import { t } from 'es6/services/localization';

export const ItemsRequiredForStudy = 2;

export const DIFFICULTY_LEVEL_BEGINNER = 1;
export const DIFFICULTY_LEVEL_LOWER_INTERMEDIATE = 2;
export const DIFFICULTY_LEVEL_INTERMEDIATE = 3;
export const DIFFICULTY_LEVEL_UPPER_INTERMEDIATE = 4;
export const DIFFICULTY_LEVEL_ADVANCED = 5;


export class Goal {
  constructor(attrs = {}) {
    // Don't want to override our getter method.
    attrs = _.omit(attrs, 'progress');

    _.defaults(this, attrs, {
      id: null,
      createdAt: null,
      updatedAt: null,
      publishedAt: null,
      isCommunity: null,
      title: null,
      description: null,
      difficultyLevel: null,
      cueLanguage: null,
      responseLanguage: null,
      icon: null,
      itemsCount: null,
      sentencesCount: null,
      usersCount: null,
      author: null,
      rights: null,
      goalItems: null,
    });

    if (this.createdAt && !(this.createdAt instanceof Date)) {
      this.createdAt = new Date(this.createdAt);
    }

    if (this.updatedAt && !(this.updatedAt instanceof Date)) {
      this.updatedAt = new Date(this.updatedAt);
    }

    if (this.publishedAt && !(this.publishedAt instanceof Date)) {
      this.publishedAt = new Date(this.publishedAt);
    }

    // Cast goal items to ItemPackage
    if (this.goalItems instanceof Array) {
      this.goalItems = this.goalItems.map((goalItem) => {
        goalItem.goalId = this.id;
        return !(goalItem instanceof ItemPackage) ? new ItemPackage(goalItem) : goalItem;
      });
    }
  }

  /**
   * Retrieves the new items count. Will use provided aggregate memory
   * to calculate number if provided. Otherwise it will use the
   * aggregateMemory set to this goal.
   *
   * aggregateMemory: AggregateMemory
   */
  getNewItemsCount(aggregateMemory = null) {
    return this.itemsCount - aggregateMemory.items.skippedItemsCount - aggregateMemory.items.studiedItemsCount;
  }

  /**
   * Retrieves the total items count (removes skipped). Will use provided
   * aggregate memory to calculate number if provided. Otherwise it will use the
   * aggregateMemory set to this goal.
   *
   * aggregateMemory: AggregateMemory
   */
  getTotalItemsCount(aggregateMemory = null) {
    return this.itemsCount - aggregateMemory.items.skippedItemsCount;
  }

 /**
   * Retrieves the total items that are ready to be studied.
   *
   * aggregateMemory: AggregateMemory
   */
  getReadyItemsCount(aggregateMemory = null) {
    return this.getNewItemsCount(aggregateMemory) + aggregateMemory.items.eligibleItemsCount;
  }

  /**
   * Returns the string for difficulty level.
   */
  getDifficultyLevel() {
    let difficultyLevel = null;

    switch (this.difficultyLevel) {
      case DIFFICULTY_LEVEL_BEGINNER:
        difficultyLevel = t('beginner');
        break;
      case DIFFICULTY_LEVEL_LOWER_INTERMEDIATE:
        difficultyLevel = t('lower intermediate');
        break;
      case DIFFICULTY_LEVEL_INTERMEDIATE:
        difficultyLevel = t('intermediate');
        break;
      case DIFFICULTY_LEVEL_UPPER_INTERMEDIATE:
        difficultyLevel = t('upper intermediate');
        break;
      case DIFFICULTY_LEVEL_ADVANCED:
        difficultyLevel = t('advanced');
        break;
    }

    return difficultyLevel;
  }

  /**
   * Can this goal do any sentence study quizzes.
   *
   * @returns {Boolean}
   */
  isSentenceStudyEnabled() {
    return this.sentencesCount > 0;
  }

  /**
   * Determines if a goal is studiable. If an aggregate memory is provided,
   * will include skippedItems to decide. If not, will use the default item
   * count.
   */
  isStudiable() {
    return this.itemsCount >= ItemsRequiredForStudy;
  }
}

export default Goal;
